/* maximun and minimum allowed size of the width of the right side bar, side bar will collapse if it is shorter */
export const MIN_RIGHT_SIDEBAR_WIDTH = 200;
/* sidebar wont be enlarged if greater */
export const MAX_RIGHT_SIDEBAR_WIDTH = 800;
